module.exports = __webpack_public_path__ + "img/product_card_discount_price_percentage.499020ee.png";